import React from 'react'
import { Link } from 'gatsby'
import kebabCase from "lodash/kebabCase"
import Img from 'gatsby-image';

const ListPost = ({ link, img, title, description, date, tag, author }) => {
    return (
        <div className="row align-items-center">
            <div className="col-md-5 col-lg-4">
                <Link to={link}>
                    <Img
                        fluid={img}
                        className="img-blog" 
                        alt={title}
                        title={title}
                    />
                </Link>
            </div>
            <div className="col-sm-12 col-md-7 col-lg-8">
                <div className="content">
                    <Link to={`/tags/${kebabCase(tag)}`} className="post-tag-mobile">{tag}</Link>
                    <h3 className="title">
                        <Link to={link}>{title}</Link>
                    </h3>
                    <p>
                        {description}
                    </p>
                    <div className="footer-post">
                        <small>{date}</small>
                        <small className="post-tag"><Link to={`/tags/${kebabCase(tag)}`}>{tag}</Link></small>
                        <small>{author}</small>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ListPost